import { Button } from '@mui/material'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface EditPaymentCloseAllBtnProps {
  onCloseAll: () => void
}

const EditPaymentCloseAllBtn = ({ onCloseAll }: EditPaymentCloseAllBtnProps) => {
  const { t } = useTranslation()
  const handleClose = () => {
    onCloseAll()
  }
  return (
    <>
      <Button onClick={handleClose} color="inherit">
        {t('loan.payment.returnToCalendar')}
      </Button>
      <div style={{ flexGrow: 1 }} />
    </>
  )
}

export default memo(EditPaymentCloseAllBtn)
